import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Footer from '../components/Footer';
import { publicAPI } from '../lib/api';

export default function Landing() {
  const navigate = useNavigate();
  const [plan, setPlan] = useState(null);

  // Pull the admin-editable plan config so the landing page can display live prices
  // and copy without redeploying. Fails silently — page still renders defaults.
  useEffect(() => {
    let alive = true;
    publicAPI.plan().then(p => { if (alive) setPlan(p); }).catch(() => {});
    return () => { alive = false; };
  }, []);

  return (
    <div className="grain relative min-h-screen">
      <Navbar onSignIn={() => navigate('/auth?mode=login')} />
      <Hero
        plan={plan}
        onPrimary={() => navigate('/auth?mode=signup')}   // "Começar"
        onSecondary={() => navigate('/auth?mode=login')}  // "Já tenho conta"
      />
      <Features plan={plan} />
      <Footer />
    </div>
  );
}
